import { AudiencesAction, AudiencesActionTypes, AudiencesState } from "../types/audience"

const initialState: AudiencesState = {
  audiences: [],
  loaded: false,
  error: null,
}

export const audiencesReducer = (state = initialState, action: AudiencesAction): AudiencesState => {
  switch (action.type) {
    case AudiencesActionTypes.FETCH_AUDIENCES_LIST:
      return {
        ...state,
        loaded: true,
      }
    case AudiencesActionTypes.FETCH_AUDIENCES_LIST_SUCCESS:
      return {
        ...state,
        loaded: false,
        audiences: action.payload,
      }
    case AudiencesActionTypes.FETCH_AUDIENCES_LIST_ERROR:
      return {
        ...state,
        loaded: false,
        error: action.payload,
      }
    default:
      return state
  }
}
